import React, { FC } from "react";
import classNames from "classnames";
import { format } from "lib/globalize-util";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { DialogFooter, DialogHeader, IDialogClasses } from "components/dialog/media-dialog";

interface IProps {
    open: boolean;
    title?: React.ReactNode | string;
    classes?: IDialogClasses;
    disabledSave?: boolean;
    disablePortal?: boolean;
    saveText?: string;
    closeText?: string;
    onSave(): void;
    onClose(): void;
}

export const MediaConfirmation: FC<IProps> = (props) => {
    const { open, title, onSave, onClose, classes, children, disabledSave, disablePortal, saveText, closeText } = props;
    const inner = useStyles();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            classes={{ root: classes?.dialog, paper: classNames(inner.paper, classes?.paper) }}
            disablePortal={disablePortal}
        >
            <DialogHeader
                className={inner.borders}
                title={title || format("Are you sure?")}
                onClose={onClose}
                classes={classes}
            />
            <DialogContent className={classNames(inner.content, classes?.content)}>{children}</DialogContent>
            <DialogFooter
                className={classNames(inner.borders, classes?.actions)}
                onSave={onSave}
                onClose={onClose}
                disabledSave={disabledSave}
                saveText={saveText || format("Yes")}
                closeText={closeText || format("No")}
            />
        </Dialog>
    );
};

const useStyles = makeStyles({
    paper: {
        maxWidth: 600,
        fontFamily: "Lato",
    },
    content: {
        paddingTop: 12,
        paddingBottom: 12,
        fontSize: 14,
    },
    borders: {
        border: "none",
    },
});

export default MediaConfirmation;
